import { render, staticRenderFns } from "./zwbookacive.vue?vue&type=template&id=c1077b40&scoped=true"
import script from "./zwbookacive.vue?vue&type=script&lang=js"
export * from "./zwbookacive.vue?vue&type=script&lang=js"
import style0 from "./zwbookacive.vue?vue&type=style&index=0&id=c1077b40&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1077b40",
  null
  
)

export default component.exports